var _path, _desc, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCardDarker16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 0c-0.553 0-1 0.447-1 1v10c0 0.553 0.447 1 1 1h14c0.553 0 1-0.447 1-1v-10c0-0.553-0.447-1-1-1zm0.5 1.5h13v1.5h-13zm0 3.5h13v5.5h-13z",
    fill: "#dd9c00",
    fillRule: "evenodd"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "358915E9-D591-4D42-BCEB-D4B0947906F4_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 9c0.553 0 1-0.447 1-1s-0.447-1-1-1-1 0.447-1 1 0.447 1 1 1z",
    fill: "#dd9c00",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10 9c0.553 0 1-0.447 1-1s-0.447-1-1-1-1 0.447-1 1 0.447 1 1 1z",
    fill: "#dd9c00",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardDarker16Px);
export default __webpack_public_path__ + "static/media/Icon_Card_Darker_16px.a31db49bcb9be36ec95db1b3794016d6.svg";
export { ForwardRef as ReactComponent };